import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/reset.less'
import Antd from 'ant-design-vue'
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');
import 'ant-design-vue/dist/antd.css'
import vue3SeamlessScroll from "vue3-seamless-scroll";
router.beforeEach(() => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
})
const app = createApp(App)

app.use(vue3SeamlessScroll)

app.use(store)

app.use(router)

app.use(Antd)

app.mount('#app')
